<script>
	
	let value = ``;
	$: temps = value.split('\n')
	$: lines = temps.filter(temp => temp != "")
	
</script>

<main>
	<h1>Get Python List</h1>
	<p>Post list here and get a list with quotes and commas.</p><p> 100% secure. Everything stays in your browser.</p>
	<textarea bind:value={value} placeholder="One item per line"></textarea>
	<p>
	{#each lines as line, i}

	{#if i+1 === lines.length}
{('"' + line + '"').trim()}<br>
{:else}
{('"' + line + '",').trim()}<br>
{/if}
	{/each}
</p>
<p class="footer">Built by <a href="https://victorbjorklund.com/" target="_blank">Victor Björklund</a>. Free forever.</p>
</main>

<style>
	textarea {
		width: 50%;
		height: 50%;
	}
	main {
		text-align: center;
		padding: 1em;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	.footer {
		font-size: smaller;
		margin-top: 300px;
	}

</style>